module.exports = __webpack_public_path__ + "static/media/bookshelf.1a016506.jpg";